import { BaseModel, UserSlimModel } from '@abb-procure/data';
import type { NotificationInboxMessage } from '../types/notification-inbox-message.type';

export class NotificationInboxMessageModel
  extends BaseModel
  implements NotificationInboxMessage
{
  readonly id: string | null;
  readonly title: string | null;
  readonly message: string | null;
  readonly data: Record<string, string | null>;
  readonly createdOn: Date;
  readonly sender: UserSlimModel | null = null;
  isRead: boolean;
  isArchived: boolean;

  constructor(data: NotificationInboxMessage) {
    super();

    this.id = data.id;
    this.title = data.title;
    this.message = data.message;
    this.data = data.data;
    this.createdOn = data.createdOn;

    if (data.sender) {
      this.sender = new UserSlimModel(data.sender);
    }

    this.isRead = data.isRead;
    this.isArchived = data.isArchived;
  }
}
